import { post, get } from '@core/request';

/**
 *
 * @param {*} 机构库Api
 * @returns
 */

// 上传
export const uploadFileApi = (params, options = {}) => {
    return post('/dataengine/cases/file/save-img', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        ...options,
    });
};

// 机构库列表
export const organizationsListApi = params => {
    return post('/user/organizations/list', params);
};

// 机构库合并
export const mergeOrganizationsApi = params => {
    return post('/user/organizations/mergeOrganizations', params);
};

// 审核拒绝
export const organizationsRejectedApi = params => {
    return get('/user/organizations/rejected', params);
};

// 审核通过
export const organizationsReviewedApi = params => {
    return get('/user/organizations/reviewed', params);
};

// 根据id获取机构信息
export const organizationsInfoApi = params => {
    return get(`/user/organizations/info/${params.id}`, params);
};

// 机构新增/编辑
export const organizationsSaveAndUpdateApi = params => {
    return post('/user/organizations/saveAndUpdate', params);
};

// 机构分组数据统计
export const organizationsGroupCountApi = params => {
    return get('/user/organizations/groupCount', params);
};

// 验证机构名称重名
export const organizationsValiNameApi = params => {
    return get('/user/organizations/valiName', params);
};

// 撤销机构合并
export const cancelMergedOrganizationsApi = params => {
    return get('/user/organizations/cancelMergedOrganizations', params);
};

// 合并机构管理列表
export const mergeListApi = params => {
    return post('/user/organizations/mergeList', params);
};

// 机构概览 - 专家列表
export const dataExpertsApi = params => {
    return get('/user/organizations/data/experts', params);
};

// 机构概览 - 案例项目列表
export const dataCaseProjectsApi = params => {
    return get('/user/organizations/data/caseProjects', params);
};

// 机构概览 - 认证信息统计
export const dataOrgMemberCountApi = params => {
    return get('/user/organizations/data/orgMemberCount', params);
};
